// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Mobile/Tablet ─────────────────────────────────── */

@media (max-width: 768px) {
    .em-title {
        font-size: 17px;
    }

    .em-subtitle,
    .em-legend-subtitle {
        font-size: 13px;
    }

    .em-inset-title {
        font-size: 14px;
    }

    .em-inset-subtitle {
        font-size: 12px;
    }

    .em-button {
        width: 28px;
        height: 28px;
    }

    .em-button text {
        font-size: 16px;
    }

    /* Prevent the tooltip from being taller than half the screen,
       and ensure it never bleeds past either edge */
    .em-tooltip {
        max-width: 150px;
        max-height: 45vh;
        /* Slightly larger shadow so it reads clearly over a map */
        box-shadow:
            0px 6px 12px rgba(0, 0, 0, 0.18),
            0px 2px 4px rgba(0, 0, 0, 0.12);
    }

    .em-tooltip-bar {
        padding: 8px 10px;
        font-size: 12px;
        line-height: 1.3;
        /* Wrap long region names rather than forcing a wide box */
        word-break: break-word;
    }

    .em-tooltip-text {
        padding: 6px 10px;
        font-size: 13px;
        line-height: 1.4;
    }

    .em-tooltip-breakdown {
        gap: 0px; /* More breathing room between rows on touch */
        padding: 8px 10px;
        padding-top: 4px;
        font-size: 12px;
    }

    .em-breakdown-color {
        width: 10px;
        height: 10px;
        margin-right: 8px;
    }

    .em-breakdown-value {
        margin-left: 10px;
    }

    /* Stacked bar SVG: stretch to fill the tooltip width instead of
       rendering at the fixed \`tw\` pixel value baked into the HTML */
    .em-tooltip-barchart-container svg {
        width: 100%;
        height: auto;
    }

    /* Compact the cx (trivariate) table on small screens */
    .em-tooltip-cx-table th,
    .em-tooltip-cx-table td {
        padding: 3px 4px;
        font-size: 11px;
    }
}

/* ── Very narrow phones (≤ 375px, e.g. iPhone SE) ────────────────── */

@media (max-width: 375px) {
    .em-tooltip {
        max-width: 150px;
        font-size: 11px;
    }

    .em-tooltip-bar {
        font-size: 12px;
        padding: 6px 8px;
    }

    .em-tooltip-breakdown {
        font-size: 11px;
        padding: 6px 8px;
    }

    .em-breakdown-label {
        /* Truncate aggressively on the narrowest screens */
        max-width: 100px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/responsive.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;oDACgD;IAChD;QACI,gBAAgB;QAChB,gBAAgB;QAChB,0DAA0D;QAC1D;;2CAEmC;IACvC;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,0DAA0D;QAC1D,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,QAAQ,EAAE,8CAA8C;QACxD,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;oEACgE;IAChE;QACI,WAAW;QACX,YAAY;IAChB;;IAEA,uDAAuD;IACvD;;QAEI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA,uEAAuE;;AAEvE;IACI;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mDAAmD;QACnD,gBAAgB;IACpB;AACJ","sourcesContent":["/* ── Mobile/Tablet ─────────────────────────────────── */\r\n\r\n@media (max-width: 768px) {\r\n    .em-title {\r\n        font-size: 17px;\r\n    }\r\n\r\n    .em-subtitle,\r\n    .em-legend-subtitle {\r\n        font-size: 13px;\r\n    }\r\n\r\n    .em-inset-title {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .em-inset-subtitle {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .em-button {\r\n        width: 28px;\r\n        height: 28px;\r\n    }\r\n\r\n    .em-button text {\r\n        font-size: 16px;\r\n    }\r\n\r\n    /* Prevent the tooltip from being taller than half the screen,\r\n       and ensure it never bleeds past either edge */\r\n    .em-tooltip {\r\n        max-width: 150px;\r\n        max-height: 45vh;\r\n        /* Slightly larger shadow so it reads clearly over a map */\r\n        box-shadow:\r\n            0px 6px 12px rgba(0, 0, 0, 0.18),\r\n            0px 2px 4px rgba(0, 0, 0, 0.12);\r\n    }\r\n\r\n    .em-tooltip-bar {\r\n        padding: 8px 10px;\r\n        font-size: 12px;\r\n        line-height: 1.3;\r\n        /* Wrap long region names rather than forcing a wide box */\r\n        word-break: break-word;\r\n    }\r\n\r\n    .em-tooltip-text {\r\n        padding: 6px 10px;\r\n        font-size: 13px;\r\n        line-height: 1.4;\r\n    }\r\n\r\n    .em-tooltip-breakdown {\r\n        gap: 0px; /* More breathing room between rows on touch */\r\n        padding: 8px 10px;\r\n        padding-top: 4px;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .em-breakdown-color {\r\n        width: 10px;\r\n        height: 10px;\r\n        margin-right: 8px;\r\n    }\r\n\r\n    .em-breakdown-value {\r\n        margin-left: 10px;\r\n    }\r\n\r\n    /* Stacked bar SVG: stretch to fill the tooltip width instead of\r\n       rendering at the fixed `tw` pixel value baked into the HTML */\r\n    .em-tooltip-barchart-container svg {\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    /* Compact the cx (trivariate) table on small screens */\r\n    .em-tooltip-cx-table th,\r\n    .em-tooltip-cx-table td {\r\n        padding: 3px 4px;\r\n        font-size: 11px;\r\n    }\r\n}\r\n\r\n/* ── Very narrow phones (≤ 375px, e.g. iPhone SE) ────────────────── */\r\n\r\n@media (max-width: 375px) {\r\n    .em-tooltip {\r\n        max-width: 150px;\r\n        font-size: 11px;\r\n    }\r\n\r\n    .em-tooltip-bar {\r\n        font-size: 12px;\r\n        padding: 6px 8px;\r\n    }\r\n\r\n    .em-tooltip-breakdown {\r\n        font-size: 11px;\r\n        padding: 6px 8px;\r\n    }\r\n\r\n    .em-breakdown-label {\r\n        /* Truncate aggressively on the narrowest screens */\r\n        max-width: 100px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
